<div class="eleco-progressbar">
    <div class="eleco-progressbar-outer">
        <div class="eleco-progressbar-inner" [style.width]="widthPC"></div>    
    </div>
</div>
